// extracted by mini-css-extract-plugin
export default {"box":"statbox_box__6oeA5","title":"statbox_title__UdxId","value":"statbox_value__Uw5CJ","icon":"statbox_icon__ORK95"};